<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How do I redeem a {{voucher_name}}?</h1>

			<p>
				You need to enter your {{voucher_name.toLowerCase()}} number on "Select Payment Methods" step of checkout or make sure to check the check box next to it if it was previously entered. Any
				remaining balance on your order must be paid with another {{voucher_name.toLowerCase()}} or credit card.
			</p>

			<div id="checkout">
				<div class="co-payments-sections-container">
					<v-flex mb2 d-flex xs12 pa-0 grow>
						<div class="co-section">
							<v-card flat width="100%" class="mb-1 pt-2">
								<div>
									<div>
										<div class="section-title">
										<h1 class="active">
											Select Payment Methods
										</h1>
									</div>
									<div>
										<div class="co-payments-sections">

											<div data-v-4ffbd12c="" class="co-payments-section-no-permissions">
												<ul data-v-4ffbd12c="" class="co-payments-selector mr-4">
													<li data-v-311f2a5c="" data-v-4ffbd12c=""><!---->
														<div data-v-311f2a5c="" class="cops-gc">
															<div data-v-311f2a5c=""
																 class="v-input my-3 v-input--selection-controls v-input--checkbox v-input--hide-details theme--light"
																 aria-label="Apply School Voucher to this order, balance: $125.00, name ends with: 7 2 T M">
																<div class="v-input__control">
																	<div class="v-input__slot">
																		<div class="v-input--selection-controls__input">
																			<input aria-label="Apply School Voucher to this order, balance: $125.00, name ends with: 7 2 T M"
																				   aria-checked="false" role="checkbox"
																				   type="checkbox" value="">
																			<div class="v-input--selection-controls__ripple"></div>
																			<i aria-hidden="true"
																			   class="v-icon material-icons theme--light">check_box_outline_blank</i>
																		</div>
																		<label aria-hidden="true"
																			   class="v-label theme--light"
																			   style="left: 0px; right: auto; position: relative;">
																			<div data-v-311f2a5c="">Apply {{voucher_name}}
																				<strong>******72TM</strong> to this
																				order (Balance: <strong>$125.00</strong>)
																			</div>
																		</label></div>
																</div>
															</div>
															<hr data-v-311f2a5c="" aria-hidden="true" tabindex="-1"
																class="v-divider theme--light">
														</div>
													</li>
												</ul>
											</div>

											<div class="co-payments-section-additional">
												<ul class="co-payments-selector mr-4">
													<template>
														<li class="cops-cc pb-3">
															<v-checkbox
																	label="Use a credit or debit card"
																	hide-details
																	class="mt-3"
															></v-checkbox>

															<v-radio-group
																	class="ml-4 mt-1 mb-3 co-select-cc-rg"
																	hide-details
															>
																<v-flex grid-list-md pa-0 grow>

																	<v-layout wrap justify-space-between>
																		<v-flex xs12 grow py-0>
																			<div>
																				<v-container pa-0>
																					<v-layout wrap>
																						<v-flex xs11>
																							<v-radio class="py-3 my-0">
																								<template v-slot:label="">
																									<div style="word-break: break-word">
																										Test, VISA ****
																										1111
																									</div>
																								</template>
																							</v-radio>
																						</v-flex>
																					</v-layout>
																				</v-container>
																			</div>

																			<v-divider></v-divider>
																		</v-flex>
																		<v-flex xs12 grow py-0>
																			<v-radio class="pt-3 my-0" :value="-1" label="Add credit or debit card"></v-radio>
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-radio-group>

															<v-divider class="mt-3"></v-divider>
														</li>

													</template>
													<li>
														<v-container grid-list-md pa-0>
															<v-flex xs6><div class="field"><span class="arrow"></span></div></v-flex>
															<v-layout wrap justify-space-between class="cops-add pb-3">

																<v-flex class="cops-add-caption">
																	<div>
																		<strong>{{voucher_label}}</strong>
																	</div>
																	<v-layout>
																		<v-flex xs8 py-0>
																			<v-text-field
																					label="Enter Code"
																					class="co-text-field"
																			></v-text-field>
																		</v-flex>
																	</v-layout>
																</v-flex>
																<v-flex class="cops-add-caption">
																	<div>
																		<strong>Add a Discount Code</strong>
																	</div>
																	<v-layout>
																		<v-flex xs8 py-0>
																			<v-text-field
																					label="Enter Code"
																					class="co-text-field"
																			></v-text-field>
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-layout>
														</v-container>
													</li>
												</ul>
											</div></div>
										</div>
									</div>
								</div>
							</v-card>
						</div>
					</v-flex>
				</div>
			</div>

			<p>
				If you have a rental item, you must add a credit card. The card will only be charged if you do not return your rental in acceptable condition.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "RedeemVoucher",

		components: {
			BaseNavLinks,
		},

		computed: {
			voucher_label() {
				const label = this.$globs.institute_info.voucher_label;
				return (!label || label === 'School Voucher') ? 'Add a School Voucher or Gift Code' : label;
			},
			voucher_name() {
				const name = this.$globs.institute_info.voucher_name;
				return name || 'School Voucher';
			}
		},

	}
</script>

<style scoped lang="less">
	@text_highlight_color: #4185f4;

	.gradient-linear(@from, @to) {
		background: mix(@from, @to);
		background: -webkit-gradient(linear, left top, left bottom, from(@from), to(@to));
		background: -webkit-linear-gradient(top, @from, @to);
		background: -o-linear-gradient(top, @from, @to);
		background: linear-gradient(to bottom, @from, @to);
	}

	.gradient-radial(@from, @to) {
		background: mix(@from, @to);
		background: -webkit-radial-gradient(@from, @to);
		background: -o-radial-gradient(@from, @to);
		background: radial-gradient(@from, @to);
	}

	.box-shadow(@shadow) {
		-webkit-box-shadow: @shadow;
		box-shadow: @shadow;
	}

	.transform(@transform) {
		-webkit-transform: @transform;
		-ms-transform: @transform;
		transform: @transform;
	}

	#checkout {
		pointer-events: none;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		cursor: default;

		a {
			color: #4185F4;
		}

		ul {
			font-size: 100%;
		}

		.theme--light.application {
			background-color: #fff !important;
		}

		.theme--light.v-label {
			color: #28323B;
		}

		.v-input--is-disabled input {
			color: #b6b6b6 !important;
		}

		.v-input .v-label {
			font-size: 15px;
		}

		#alt_email_sl {
			padding-top: 5px;
			padding-bottom: 5px;

			.v-icon {
				display: none !important;
			}
			.v-label {
				cursor: default !important;
			}
		}

		#co-header-wrapper {
			border-bottom: 2px solid #ccc;
			margin-bottom: 20px;

			#co-header {
				@media screen and (min-width: 1024px) {
					width: 1000px;
				}
				margin: 10px auto;
				position: relative;
				display: flex;
				justify-content: space-between;
				align-items: center;

				@media screen and (max-width: 600px){
					&>div {
						padding: 0 20px;
					}
				}

				.co-header-logo {
					flex: 1;
					img {
						margin-left: 0;
						@media screen and (max-width: 600px){
							max-width: 200px;
						}
						max-height: 66px;
					}
				}

				.co-header-cart {
					display: block;
					height: 20px;

					a {
						color: black;
						text-decoration: none;
					}
				}
			}
		}

		#co-body {
			#co-content {
				@media screen and (min-width: 1024px) {
					width: 1000px;
				}
				margin: 0 auto;

				.co-content-header {
					margin-bottom: 10px;
					display: flex;
					justify-content: space-between;
					align-items: center;

					@media screen and (max-width: 600px) {
						margin: 0 10px 10px;
						flex-direction: column;
					}

					.co-content-header-right {
						display: block;
						font-size: 15px;
						color: #777B80;
						font-weight: normal;
					}
				}
			}
		}

		h2 {
			background: none;
			color: #4185F4;
			text-transform: none;
			font-size: 16px;
		}

		.co-text-highlight {
			color: @text_highlight_color;

			.v-icon {
				color: inherit;
			}
		}

		.section-title {
			overflow: hidden;
			margin: 16px 24px 0;
			padding-bottom: 8px;
			border-bottom: 1px solid #ccc;

			h1 {
				color: #000;
				font-weight: bold;
				font-size: 19px;
				float: left;
				overflow: hidden;
				border: none;
				margin: 0;
				padding: 0;

				&.active {
					color: @text_highlight_color;
				}

				> strong {
					display: block;
					float: left;
					border-radius: 50%;
					width: 30px;
					height: 30px;
					text-align: center;
					vertical-align: middle;
					line-height: 30px;
					margin-right: 10px;
				}

				> span > strong {
					color: @text_highlight_color;
				}
			}

			> div {
				float: right;

				> a {
					color: #4185F4;
					font-size: 16px;
					font-weight: bold;
				}
			}

			&.no-border {
				border: none;
			}
		}

		.co-submit-panel {
			margin: 0px 20px;
		}

		.co-section-todo {
			color: #ccc;

			h1 {
				margin: 20px;
				color: #ccc;
				padding-bottom: 15px;
				border-bottom: 1px solid #ccc;
			}

			p {
				padding: 0 20px 20px;
				margin: 0;
			}
		}

		/deep/ .v-input.co-text-field {
			.v-input__slot {
				border: 1px solid #757575;
				border-radius: 4px;

				input[type=text], input[type=email], input[type=password] {
					padding: 8px 10px;
				}

				&:before, &:after {
					display: none;
				}

				.v-label {
					padding: 0 5px;
					background-color: #fff;
					margin-left: 5px;
					height: 20px;

					&.v-label--active {
						margin-left: 10px;
						padding-top: 5px;
						height: 25px;
						z-index: 1;
					}

					&.primary--text {
						color: #28323B !important;
					}
				}
			}

			.v-input__control {
				.v-messages {
					min-height: 0 !important;
				}
			}

			&.v-input--is-focused {
				.v-input__slot {
					border: 1px solid #28323B;
				}
			}
		}

		.co-change-link {
			font-size: 14px !important;
			font-weight: bold;
		}

		.login-button-for-3rd-party-auth {
			padding: 0 50px;
			font-size: 120%;

			span {
				display: inline-block;
				font-family: 'icons2014';
				margin: -2px 0 0 5px;
				vertical-align: middle;
				font-size: 22px;
				font-variant: small-caps;
				color: #fff;
			}
		}

		.co-submit-panel {
			display: flex;
			align-items: center;

			.co-submit-total {
				padding-left: 25px;
				font-size: 16px;
			}
		}

		.co-payments-sections-container {
			width: 100%;

			.co-payments-sections {
				.co-payments-section-with-permissions,
				.co-payments-section-without-permissions {
					.co-payments-section-books {
						padding: 0 30px;

						h3 {
							color: #898C90;
							font-weight: normal;
						}

						.co-permissions-totals {
							padding-top: 10px;
							border-top: 1px solid #ccc;
							margin-top: 10px;
						}
					}
				}

				.co-payments-section-with-permissions {
					padding: 20px 0 20px 24px;
					border-bottom: 1px solid #ccc;
				}

				.co-payments-section-without-permissions {
					padding: 20px 0 0 24px;
				}

				.co-payments-section-no-permissions {
					padding: 0 0 0 24px;
				}

				.co-payments-section-additional {
					padding: 0 0 0 24px;
				}

				ul.co-products-list {
					list-style: none;
					padding: 10px 0 0;

					> li {
						overflow: hidden;
						padding: 10px 0;

						&:first-child {
							border-top: none;
						}

						h3 {
							color: #787878;
							font-size: 16px;
							font-weight: normal;
							margin-bottom: 10px;
							text-transform: uppercase;
						}

						.copl-cover {
							display: block;
							float: left;
							width: 8%;
							margin-right: 2%;
						}

						.copl-info {
							display: block;
							box-sizing: border-box;
							float: left;
							width: 90%;
							padding: 0;

							h4 {
								font-size: 15px;
							}

							div {
								font-size: 14px;
							}
						}
					}
				}


				/deep/ .co-payments-container-radio-group {
					width: 100%;

					> .v-input__control {
						flex-grow: 1;
					}
				}

				.co-payments-container {
					overflow: hidden;
					width: 100%;

					.co-payments-section-content {
						padding: 20px;
					}

				}

				&.co-payments-sections-brief {
					> ul {
						list-style: none;
						margin: 0;
						padding: 0 0 0 40px;

						> li {
							font-size: 16px;
							padding: 5px 0;
						}
					}
				}

				/deep/ ul.co-payments-selector {
					list-style: none;
					padding: 0;
					margin: 0;

					> li {
						strong {
							font-style: normal;
						}

						.co-select-cc-rg {
							.v-input__control {
								flex-grow: 1 !important;
							}
						}

						&.cops-cc {
							ul.cops-ccs-list {
								list-style: none;

								> li {
									padding: 15px 0px;
									border-bottom: 1px solid #E0E0E0;
								}
							}

							.co-cc-type-selector-container {
								padding: 16px 0 0 0;

								.co-cc-type-selector-title {
									padding: 0 0 0 28px;
								}

								.co-cc-type-selector {
									padding: 0 0 0 48px;
								}
							}
						}


						.cops-3rd-party {
							border-bottom: 1px solid #E0E0E0;
							padding: 0 0 20px;
							margin-bottom: 20px;
							display: flex;
							justify-content: flex-start;

							.cops-3rd-party-btn {
								display: flex;
								justify-content: center;
							}

							.flex {
								&:empty {
									display: none;
									flex: none;
								}
							}

						}

						.cops-flexpay {
							margin-bottom: 20px;
						}

						.cops-add {
							padding-top: 20px;

							@media screen and (max-width: 600px) {
								flex-direction: column;
							}

							.cops-add-caption {
								flex: 1;
							}
						}

						.co-code-submit-btn-block {
							padding-top: 7px;
							margin-top: -5px;
						}
					}
				}
			}

			.co-save-password-block {
				margin-top: 10px;
				border-top: 1px solid #E0E0E0;

				.co-save-password-block-title {
					margin-bottom: 10px;
					color: @text_highlight_color;
				}

				.co-save-password-form {
					margin: 0 0 15px;
				}
			}
		}

		.co-captcha-panel {
			margin: 10px 0;
			border-top: 1px solid #E0E0E0;
			padding: 15px 24px 0;
			@media screen and (max-width: 600px) {
				padding: 10px 0 0;
				display: flex;
				justify-content: center;
				max-width: 100vw;
			}
		}

		.third-party-payment-info-block {
			align-items: center;

			p {
				flex: 1;
				margin-bottom: 0;
			}
		}

		.co-submit-placing-order {
			padding: 30px 32px 20px;

			h4 {
				font-weight: normal;
				font-style: italic;
				font-size: 18px;
			}
		}

		/deep/ .v-text-field .v-label {
			top: 6px !important;
		}

		/deep/ .co-sc-cvv-block {
			padding: 0 0 16px 48px !important;

			.v-input {
				padding-top: 0;
				margin-top: 0;
			}
		}

		.arrow {
			position: absolute;
			top: 93%;
			margin-top: 5px;
			left: 18%;
			height: 0;
			width: 0;
			border: 12px solid;
			border-color: red red transparent transparent;
			.transform(rotate(-45deg) translateX(-50%));
			&:before {
				content: '';
				position: absolute;
				top: 0;
				right: 0;
				display: block;
				height: 10px;
				width: 26px;
				background-color: red;
				.transform(rotate(-45deg) translateY(5px));
			}
		}

	}




</style>
